import React from 'react';
import { useIntl } from 'react-intl';
import { FormProvider } from 'react-hook-form';
import { computeText } from '@/locales/utils';
import Wizard from '@/components/atoms/Wizard';
import RawModal from '@/components/atoms/RawModal';
import { useImportCustomersModalVM } from './ImportCustomersModal.viewmodel';
import { ImportModalContainer } from './ImportCustomersModal.style';

type ImportCustomersModalProps = {
    isOpen: boolean;
    onHide: () => void;
    brandId: number;
    onImportSuccess?: () => void;
};

export const ImportCustomersModal: React.FunctionComponent<React.PropsWithChildren<ImportCustomersModalProps>> = ({
    isOpen,
    onHide,
    brandId,
    onImportSuccess,
}) => {
    const intl = useIntl();
    const { form, currentStep, steps, canValidate, isLoading, handleHide } = useImportCustomersModalVM({
        onHide,
        brandId,
        onImportSuccess,
    });

    return (
        <RawModal isOpen={isOpen} onHide={handleHide}>
            <FormProvider {...form}>
                <ImportModalContainer>
                    <Wizard
                        width={600}
                        selectedStep={currentStep}
                        steps={steps}
                        validateLabel={computeText(intl, 'button.import')}
                        onValidate={() => {}}
                        isLoading={isLoading}
                        canValidate={canValidate}
                    />
                </ImportModalContainer>
            </FormProvider>
        </RawModal>
    );
};
